import React from 'react';
import api from "../../../utils/api"; 
import './Analysis.css';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  PieChart, Pie, Cell, LineChart, Line, AreaChart, Area
} from 'recharts';

// Цветовая палитра для графиков
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#8DD1E1'];

export const Analysis = () => {

  const [data, setData] = React.useState(null)
  React.useEffect(() => {
        api.getAnalysis()
        .then((res)=> {
           console.log(res)
            setData(res)
        })
    }, [])
  if (!data) return <div>Загрузка данных...</div>;
  const { charts, summary, subscriptionStats } = data;

  // Компонент для столбчатой диаграммы
  const BarChartComponent = ({ data, title, xKey = "name", yKey = "value", barColor = "#8884d8" }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} angle={-45} textAnchor="end" height={80} fontSize={12} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey={yKey} fill={barColor} name="Количество" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для круговой диаграммы
  const PieChartComponent = ({ data, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} пользователей`, 'Количество']} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для линейного графика
  const LineChartComponent = ({ data, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="value" stroke="#8884d8" name="Количество" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  // Компонент для статистических карточек
  const StatCard = ({ title, value, subtitle, color = "#0088FE" }) => (
    <div className="stat-card" style={{ borderLeftColor: color }}>
      <div className="stat-value" style={{ color }}>{value}</div>
      <div className="stat-title">{title}</div>
      {subtitle && <div className="stat-subtitle">{subtitle}</div>}
    </div>
  );

  // Компонент для таблицы топ продуктов
  const TopProductsTable = ({ products, title }) => (
    <div className="chart-container">
      <h3>{title}</h3>
      <div className="table-container">
        <table className="products-table">
          <thead>
            <tr>
              <th>Продукт</th>
              <th>Количество</th>
              <th>Процент</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <tr key={product.id}>
                <td>
                  <span className="product-rank">{index + 1}</span>
                  {product.name}
                </td>
                <td>{product.count}</td>
                <td>{product.percentage}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="analysis-dashboard">
      <header className="dashboard-header">
        <h1>📊 Аналитика пользователей с платными подписками</h1>
        <div className="header-stats">
          <StatCard 
            title="Всего пользователей" 
            value={subscriptionStats.totalUsers} 
          />
          <StatCard 
            title="С подписками" 
            value={subscriptionStats.paidUsers} 
            subtitle={`${subscriptionStats.paidUsersPercentage}%`}
            color="#00C49F"
          />
        </div>
      </header>

      {/* Основная статистика */}
      <section className="section">
        <h2>📈 Основная статистика</h2>
        <div className="stats-grid">
          <StatCard 
            title="Средний размер семьи" 
            value={summary.averageFamilySize} 
          />
          <StatCard 
            title="Популярная диета" 
            value={summary.mostPopularDiet} 
          />
          <StatCard 
            title="Популярная утварь" 
            value={summary.mostPopularKitchenware} 
          />
          <StatCard 
            title="Пользователей с настройками" 
            value={summary.usersWithSettings} 
          />
        </div>
      </section>

      {/* Демографические данные */}
      <section className="section">
        <h2>👥 Демографические данные</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.gender} 
              title="Распределение по полу" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.ages.slice(0, 15)} 
              title="Топ-15 возрастов" 
            />
          </div>
        </div>
      </section>

      {/* Приемы пищи */}
   <section className="section">
  <h2>🍽️ Приемы пищи</h2>
  <div className="charts-row">
    <div className="chart-wrapper">
      <BarChartComponent 
        data={
          charts.powerMode && charts.powerMode[0] && charts.powerMode[0].value
            ? Object.entries(charts.powerMode[0].value).map(([name, value]) => ({ name, value }))
            : []
        } 
        title="Приемы пищи" 
      />
    </div>
    <div className="chart-wrapper">
      <BarChartComponent 
        data={
          charts.powerMode && charts.powerMode[1] && charts.powerMode[1].value
            ? Object.entries(charts.powerMode[1].value).map(([name, value]) => ({ name, value }))
            : []
        } 
        title="Типы блюд" 
        barColor="#00C49F"
      />
    </div>
  </div>
</section>

      {/* Диеты и утварь */}
      <section className="section">
        <h2>🥗 Предпочтения в питании</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.dietTypes.slice(0, 10)} 
              title="Топ-10 типов диет" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.kitchenware.slice(0, 10)} 
              title="Топ-10 кухонной утвари" 
              barColor="#FF8042"
            />
          </div>
        </div>
      </section>

      {/* Время готовки и калории */}
      <section className="section">
        <h2>⏱️ Время и калории</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.cookingTime.slice(0, 15)} 
              title="Топ-15 времени готовки (минуты)" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.calories.slice(0, 15)} 
              title="Топ-15 диапазонов калорий" 
              barColor="#FFBB28"
            />
          </div>
        </div>
      </section>

      {/* Стоп-лист */}
      <section className="section">
        <h2>🚫 Стоп-лист продуктов</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <TopProductsTable 
              products={charts.topProducts} 
              title="Топ-10 исключаемых продуктов" 
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.calorieTracking} 
              title="Учет калорий и нутриентов" 
            />
          </div>
        </div>
      </section>

      {/* Дополнительная статистика */}
      <section className="section">
        <h2>📋 Дополнительные настройки</h2>
        <div className="charts-row">
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.familySize} 
              title="Размер семьи" 
            />
          </div>
          <div className="chart-wrapper">
            <PieChartComponent 
              data={charts.periodAnalysis} 
              title="Период анализа" 
            />
          </div>
          <div className="chart-wrapper">
            <BarChartComponent 
              data={charts.macronutrients.slice(0, 10)} 
              title="Топ-10 макронутриентов" 
              barColor="#8884D8"
            />
          </div>
        </div>
      </section>

      {/* Детальная статистика по стоп-листу */}
      <section className="section">
        <h2>📊 Детальная статистика стоп-листа</h2>
        <div className="stats-grid">
          <StatCard 
            title="Всего уникальных продуктов в стоп-листах" 
            value={charts.stopProducts.length} 
          />
          <StatCard 
            title="Самый популярный исключаемый продукт" 
            value={charts.topProducts[0]?.name || 'Нет данных'} 
          />
          <StatCard 
            title="Пользователей с этим продуктом" 
            value={`${charts.topProducts[0]?.percentage || 0}%`} 
          />
        </div>
      </section>
    </div>
  );
};

/*export function Analysis(props) {
   const [data, setData] = React.useState([])
    React.useEffect(() => {
        api.getAnalysis()
        .then((res)=> {
           console.log(res)
            setData(res)
        })
    }, [])
    
    
    
  return (
    <main className='content section__row'>
      <h1></h1> 
      <section className='analiys__section'>
        <h2>Типы питания</h2>
        {Object.values(data).length > 0 && data.diets.length > 0 && 
       <BarChart
       width={500}
       height={300}
       data={data.diets}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="name" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Время приготовления</h2>
        {Object.values(data).length > 0 && data.cookingTimes.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.cookingTimes}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="time" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Калорийность</h2>
        <p>Без калорийности: {Object.values(data).length > 0 && data.notcals}</p>
        {Object.values(data).length > 0 && data.cals.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.cals}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="cals" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Приемы пищи</h2>
        {Object.values(data).length > 0 && data.meals.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.meals}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="nameRu" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Оборудование</h2>
        {Object.values(data).length > 0 && data.wares.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.wares}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="name" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Период готовки</h2>
        {Object.values(data).length > 0 && data.period.length > 0 &&  
       <BarChart
       width={500}
       height={300}
       data={data.period}
       margin={{
         top: 20, right: 30, left: 20, bottom: 5,
       }}
     >
       <CartesianGrid strokeDasharray="3 3" />
       <XAxis dataKey="period" />
       <YAxis />
       <Tooltip />
       <Legend />
       <Bar dataKey="count" fill="#8884d8" />
     </BarChart>
        }
      </section>
      <section className='analiys__section'>
        <h2>Продукты</h2>
        <div className='analisys__block'>
        {Object.values(data).length > 0 && data.product.length > 0 &&  
          data.product.map(produc => (
              <div className='analisys__item'>
              <p>{produc.nameRu}</p>
              <p>{produc.count}</p>
              </div>
          ))
        }
        </div>
      </section>
      <section className='analiys__section'>
        <h2>Лайки</h2>
        <div className='analisys__block'>
        {Object.values(data).length > 0 && data.likes.length > 0 &&  
          data.likes.map(like => (
              <div className='analisys__item'>
              <p>{like.name}</p>
              <p>{like.count}</p>
              </div>
          ))
        }
        </div>
      </section>
    </main>
)
   
}*/
